import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VendorAddNewModel } from '@app/interfaces';
import { RelatedVendorUpdateModel, VendorModel } from '@app/models/fund-management';
import { VendorPaymentsResponse, VendorSearch } from '@app/modules/fund-management/reports/models/vendor-payments';
import { ApiResponse } from '@app/shared/models/common';
import { InvoiceVendorEmployee } from '../../../reports/models/invoice-due.model';
import { VendorResponse } from '../components/related-vendors/models/vendor';

@Injectable()
export class VendorService {
	endpointBase = '/api/vendor';

	constructor(private readonly http: HttpClient) {}

	search(
		searchText: string,
		pageSize: number,
		topLevelOnly: boolean,
		idsToIgnore: number[],
		activeOnly: boolean = undefined,
		asChild: boolean = undefined
	): Observable<any> {
		return this.http.get(`${this.endpointBase}/search`, {
			params: {
				limit: pageSize.toString(),
				name: searchText,
				topLevelOnly: topLevelOnly.toString(),
				idsToIgnore: idsToIgnore.join(','),
				statusId: activeOnly === true ? '1' : null,
				asChild: asChild === true ? asChild.toString() : null,
			},
		});
	}

	getList(onlyActivePOs = false): Observable<ApiResponse<'vendors', VendorModel[]>> {
		return this.http.get<ApiResponse<'vendors', VendorModel[]>>(`${this.endpointBase}/list`, {
			params: {
				onlyActivePOs,
			},
		});
	}

	getVendor(id: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${id}`);
	}

	getRelatedVendors(id: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${id}/related-vendors`);
	}

	addVendor(vendor: VendorAddNewModel): Observable<any> {
		return this.http.post(`${this.endpointBase}`, vendor);
	}

	updateRelatedVendors(id: number, model: RelatedVendorUpdateModel): Observable<any> {
		return this.http.put(`${this.endpointBase}/${id}/related-vendors`, model);
	}

	getInvoicedVendorsAndOrEmployees(includeEmployeeReimbursements: boolean, employeeReimbursementsOnly: boolean): Observable<InvoiceVendorEmployee> {
		return this.http.get<InvoiceVendorEmployee>(`${this.endpointBase}/getInvoicedVendorsEmployees`, {
			params: {
				IncludeEmployeeReimbursements: includeEmployeeReimbursements,
				EmployeeReimbursementsOnly: employeeReimbursementsOnly,
			},
		});
	}

	getVendorsByPage(vendorPaging: VendorSearch): Observable<VendorPaymentsResponse> {
		return this.http.post<VendorPaymentsResponse>(`${this.endpointBase}/getByPage`, vendorPaging);
	}

	getVendors(): Observable<VendorResponse> {
		return this.http.get<VendorResponse>(this.endpointBase + '/list');
	}

	getDeductionRegisterVendors(): Observable<ApiResponse<'vendors', VendorModel[]>> {
		return this.http.get<ApiResponse<'vendors', VendorModel[]>>(`${this.endpointBase}/getDeductionRegisterVendors`);
	}
}
